var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#898EA2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.8428V13C2 13.5523 2.44772 14 3 14H4.15721C4.42243 14 4.67679 13.8946 4.86432 13.7071L9.86432 8.70711C10.2548 8.31658 10.2548 7.68342 9.86432 7.29289L8.70711 6.13568C8.31658 5.74515 7.68342 5.74515 7.29289 6.13568L2.29289 11.1357C2.10536 11.3232 2 11.5776 2 11.8428Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 3.86432L12.1357 2.70711C11.7452 2.31658 11.112 2.31658 10.7215 2.70711L9.56425 3.86432C9.17373 4.25485 9.17373 4.88801 9.56425 5.27854L10.7215 6.43575C11.112 6.82627 11.7452 6.82627 12.1357 6.43575L13.2929 5.27854C13.6834 4.88801 13.6834 4.25485 13.2929 3.86432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5f327ba15c596748f35348d69b1747c3.svg";
export { ForwardRef as ReactComponent };